/*
 * De donde sale cada foto del sitio.
 *
 * Los datos ya NO viven aqui: viven en fotos.json, que es lo que edita
 * Valentina desde emidia.cl/admin. Este archivo solo les da la forma que
 * esperan los componentes. Para cambiar una foto no hay que tocar codigo.
 *
 * Las fotos de las lineas de trabajo no estan aca: viven adentro de cada
 * servicio, en servicios.json, para que se puedan agregar y sacar de a una.
 *
 *   orientacion: "retrato"     -> 4:5
 *   orientacion: "panoramica"  -> 3:2
 */

import datos from './fotos.json';
import ruta from './ruta';

const foto = (entrada, orientacion) => ({
  src: ruta(entrada.archivo),
  orientacion: entrada.orientacion ?? orientacion,
  alt: entrada.alt,
});

export const hero = foto(datos.hero, 'panoramica');

export const retratoValentina = foto(datos.valentina, 'retrato');

export const fotosProceso = [
  foto(datos.procesoRamo, 'retrato'),
  foto(datos.procesoPrensado, 'retrato'),
  foto(datos.procesoComposicion, 'retrato'),
];

/* El carrusel: cantidad libre y cada foto elige su orientacion. */
export const galeria = datos.galeria.map((entrada) => foto(entrada, 'retrato'));
